/**
 * EmpresaPermisoEntity - Entidad de Dominio
 *
 * Representa un permiso habilitado para una empresa específica.
 * Response de: GET /api/empresa-permiso/v1/empresa/{empresaId}
 */

export interface EmpresaPermisoData {
  id: number;
  empresaId: number;
  nombreEmpresa: string;
  permisoId: number;
  nombrePermiso: string;
  modulo: string;
  accion: string;
  descripcion: string;
  habilitado: boolean;
  estado: string;
}

export class EmpresaPermisoEntity {
  private constructor(
    public readonly id: number,
    public readonly empresaId: number,
    public readonly nombreEmpresa: string,
    public readonly permisoId: number,
    public readonly nombrePermiso: string,
    public readonly modulo: string,
    public readonly accion: string,
    public readonly descripcion: string,
    public readonly habilitado: boolean,
    public readonly estado: string
  ) {
    Object.freeze(this);
  }

  static fromPersistence(data: EmpresaPermisoData): EmpresaPermisoEntity {
    return new EmpresaPermisoEntity(
      data.id,
      data.empresaId,
      data.nombreEmpresa,
      data.permisoId,
      data.nombrePermiso,
      data.modulo,
      data.accion,
      data.descripcion,
      data.habilitado,
      data.estado
    );
  }

  get esActivo(): boolean {
    return this.estado === 'ACTIVO' && this.habilitado;
  }
}
